import { render, staticRenderFns } from "./StrateAvailable.vue?vue&type=template&id=2f60a822&scoped=true&"
import script from "./StrateAvailable.vue?vue&type=script&lang=js&"
export * from "./StrateAvailable.vue?vue&type=script&lang=js&"
import style0 from "./StrateAvailable.vue?vue&type=style&index=0&id=2f60a822&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f60a822",
  null
  
)

export default component.exports